import { render, staticRenderFns } from "./IconContainer.vue?vue&type=template&id=2e0ea45c&"
import script from "./IconContainer.vue?vue&type=script&lang=js&"
export * from "./IconContainer.vue?vue&type=script&lang=js&"
import style0 from "./IconContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports